// extracted by mini-css-extract-plugin
module.exports = {"select":"select_select__3c9r6"};